import { getEndDate, getSessionLink, getStartDate, SessionState } from "@kvix/shared";
import { format, isToday, isTomorrow } from "date-fns";
import { enGB, sv } from "date-fns/locale";
import i18next from "i18next";
import React, { useMemo } from "react";
import { CardBase } from "./partials/CardBase";
import { CardMeta } from "./partials/CardMeta";
import { CardWrapper } from "./partials/CardWrapper";
export const UpcomingSessionCard = (props) => {
    var _a;
    const { options, user, filterByChip, state, thumbnailUrl, wide, fullWidth, hideMeta, isLiked, displayDateLabel } = props;
    const start = getStartDate(options);
    const end = getEndDate(options);
    const now = new Date();
    const isLive = state === SessionState.Running;
    const isFinished = state === SessionState.Finished;
    const isStarting = !isLive && !isFinished && now >= start && now < end;
    const isCancelled = state === SessionState.Cancelled;
    const link = getSessionLink(Object.assign(Object.assign({}, props.options), { state }), user);
    const startTime = useMemo(() => {
        const time = format(start, "HH:mm", {
            locale: i18next.language === "sv-SE" ? sv : enGB
        });
        const label = isTomorrow(start)
            ? ""
            : format(start, "eee", {
                locale: i18next.language === "sv-SE" ? sv : enGB
            });
        return !props.displayDateLabel || isToday(start) ? (time) : (React.createElement(React.Fragment, null,
            React.createElement("span", { style: { textTransform: "capitalize", fontWeight: 500 } }, label),
            " ",
            time));
    }, [start, props.displayDateLabel]);
    return (React.createElement(CardWrapper, { wide: wide, fullWidth: fullWidth },
        React.createElement(CardBase, { imageUrl: options.imageUrl, thumbnailUrl: thumbnailUrl, title: options.title, instructorName: options.instructorName, rating: options.rating, link: link, partnerTitle: options.partnerTitle, goesLiveAt: startTime, isLive: isLive, isFinished: isFinished, isCancelled: isCancelled, isStarting: isStarting, isLiked: isLiked, bookedUsersSummary: options.bookedUsersSummary, wide: wide }),
        !hideMeta && (React.createElement(CardMeta, { duration: options.duration, language: ((_a = options.tags) === null || _a === void 0 ? void 0 : _a.includes("English")) ? "English" : "Swedish", filterByChip: filterByChip }))));
};
//# sourceMappingURL=UpcomingSessionCard.js.map